<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ListPageShell>
        <template #header>
      <div class="list-page-panel is-header-minimal">
        <div class="list-page-heading">
          <div class="list-page-heading-main">
            <h1 class="list-page-title">部门管理</h1>
            <p class="list-page-description">维护部门树结构、负责人、排序及状态信息。</p>
          </div>
          <div class="flex items-center gap-2">
            <!-- 操作按钮区域 -->
            <button
              class="btn-secondary inline-flex items-center gap-1"
              @click="toggleAllTrees"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
              </svg>
              展开/折叠
            </button>
          </div>
        </div>
      </div>

    <!-- 部门树表格 -->
    </template>
    <div class="data-table-shell">
      <div v-if="loading" class="p-8 text-center text-slate-500">
        <svg class="animate-spin w-6 h-6 mx-auto mb-2 text-primary-600" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        加载中...
      </div>
      <div v-else class="data-table-scroll">
      <table class="data-table">
        <thead class="data-table-head">
          <tr>
            <th class="data-table-th text-left">部门名称</th>
            <th class="data-table-th text-left w-32">部门编码</th>
            <th class="data-table-th text-left w-24">排序</th>
            <th class="data-table-th text-left w-24">负责人</th>
            <th class="data-table-th text-left w-24">状态</th>
            <th class="data-table-th text-left w-32">操作</th>
          </tr>
        </thead>
        <tbody class="data-table-body">
          <DeptTreeItem
            :items="deptTree"
            :expanded-ids="expandedIds"
            @toggle="toggleTree"
            @add="openAddModal"
            @edit="openEditModal"
            @delete="handleDelete"
          />
        </tbody>
      </table>
      </div>
    </div>

    <!-- Modal Backdrop -->
    <div v-if="showModal" class="fixed inset-0 z-50" @click.self="closeModal">
      <div class="modal-backdrop absolute inset-0" style="background-color: rgba(0, 0, 0, 0.5);"></div>
    </div>

    <!-- Delete Confirm Modal -->
    <div v-if="showDeleteModal" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="modal-backdrop absolute inset-0" style="background-color: rgba(0, 0, 0, 0.5);" @click="closeDeleteModal"></div>
      <div class="modal-content relative bg-white rounded-xl shadow-xl w-full max-w-sm mx-4" style="animation: slideIn 0.2s ease-out;">
        <div class="p-6 text-center">
          <div class="w-12 h-12 mx-auto mb-4 text-red-500">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
          </div>
          <h3 class="text-lg font-semibold text-slate-900 mb-2">确定要删除吗？</h3>
          <p class="text-sm text-slate-500 mb-6">删除后无法恢复，请确认是否删除。</p>
          <div class="flex items-center justify-center gap-3">
            <button @click="closeDeleteModal" class="btn-secondary">取消</button>
            <button @click="confirmDelete" class="btn-danger-secondary">确定删除</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Add/Edit Modal -->
    <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="modal-backdrop absolute inset-0" style="background-color: rgba(0, 0, 0, 0.5);" @click="closeModal"></div>
      <div class="modal-content relative bg-white rounded-xl shadow-xl w-full max-w-lg mx-4" style="animation: slideIn 0.2s ease-out;">
        <div class="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <h3 class="text-lg font-semibold text-slate-900">{{ isEdit ? '修改部门' : '新增部门' }}</h3>
          <button @click="closeModal" class="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="p-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">上级部门</label>
            <select v-model="form.parentId" class="form-select-native w-full">
              <option value="">无（顶级部门）</option>
              <option v-for="dept in allDepts" :key="dept.id" :value="dept.id">{{ dept.name }}</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">部门名称 <span class="text-red-500">*</span></label>
            <input v-model="form.name" type="text" class="form-input w-full" placeholder="请输入部门名称">
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">部门编码</label>
            <input v-model="form.code" type="text" class="form-input w-full" placeholder="请输入部门编码">
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">部门主管</label>
            <UserSelector v-model="form.managerUserId" placeholder="请选择部门主管" />
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">联系电话</label>
            <input v-model="form.phone" type="text" class="form-input w-full" placeholder="请输入联系电话">
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">排序号</label>
            <input v-model.number="form.sort" type="number" class="form-input w-full" placeholder="数字越大越靠后">
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">状态</label>
            <select v-model="form.status" class="form-select-native w-full">
              <option :value="true">正常</option>
              <option :value="false">停用</option>
            </select>
          </div>
        </div>
        <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl">
          <button @click="closeModal" class="btn-secondary">取消</button>
          <button @click="saveDept" class="btn-primary">确定</button>
        </div>
      </div>
    </div>
  </ListPageShell>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { getDeptTree, createDept, updateDept, deleteDept } from '@/api/dept'
import ListPageShell from '@/components/ListPageShell.vue'
import UserSelector from '@/components/UserSelector/index.vue'
import DeptTreeItem from './DeptTreeItem.vue'

// 加载状态
const loading = ref(false)

// 部门树
const deptTree = ref([])

// 获取部门列表
async function fetchDepts() {
  loading.value = true
  try {
    const data = await getDeptTree()
    console.log('API返回数据:', data)
    console.log('数据类型:', typeof data, Array.isArray(data))
    console.log('deptTree值:', data)
    // 确保 children 是数组
    const normalizeChildren = (items) => {
      if (!items || !Array.isArray(items)) return []
      return items.map(item => ({
        ...item,
        children: item.children && item.children.length > 0 ? normalizeChildren(item.children) : []
      }))
    }
    deptTree.value = normalizeChildren(data)
    console.log('处理后deptTree:', deptTree.value)
    buildAllDepts()
  } catch (error) {
    console.error('获取部门列表错误:', error)
    ElMessage.error(error.message || '获取部门列表失败')
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchDepts()
})

// 获取所有部门（扁平化）
const allDepts = ref([])
function buildAllDepts() {
  allDepts.value = []
  function traverse(items) {
    for (const item of items) {
      allDepts.value.push({ id: item.id, name: item.name })
      if (item.children && item.children.length > 0) {
        traverse(item.children)
      }
    }
  }
  traverse(deptTree.value)
}
buildAllDepts()

// 展开/折叠状态
const expandedIds = ref([])
const allExpanded = ref(false)

// 模态框状态
const showModal = ref(false)
const showDeleteModal = ref(false)
const isEdit = ref(false)
const pendingDelete = ref(null)

// 表单数据
const form = reactive({
  id: '',
  name: '',
  code: '',
  sort: 0,
  managerUserId: null,
  phone: '',
  status: true,
  parentId: null,
  parentName: ''
})

// 切换单个树节点
function toggleTree(deptId) {
  const index = expandedIds.value.indexOf(deptId)
  if (index > -1) {
    expandedIds.value.splice(index, 1)
  } else {
    expandedIds.value.push(deptId)
  }
}

// 展开/折叠所有
function toggleAllTrees() {
  allExpanded.value = !allExpanded.value
  if (allExpanded.value) {
    expandedIds.value = deptTree.value.filter(d => d.children && d.children.length > 0).map(d => d.id)
  } else {
    expandedIds.value = []
  }
}

// 打开新增模态框
function openAddModal(dept) {
  isEdit.value = false
  form.id = ''
  form.parentId = dept ? dept.id : null
  form.parentName = dept ? dept.name : ''
  form.name = ''
  form.code = ''
  form.sort = 0
  form.managerUserId = null
  form.phone = ''
  form.status = true
  showModal.value = true
}

// 打开编辑模态框
function openEditModal(dept) {
  isEdit.value = true
  form.id = dept.id
  form.name = dept.name
  form.code = dept.code || ''
  form.sort = dept.sort || 0
  form.managerUserId = dept.managerUserId || null
  form.phone = dept.phone || ''
  form.status = dept.status !== undefined ? dept.status : true
  form.parentId = dept.parentId || null
  form.parentName = dept.parentId === null || dept.parentId === 0 ? '' : getParentName(dept.id)
  showModal.value = true
}

// 获取父级部门名称
function getParentName(deptId) {
  for (const dept of deptTree.value) {
    if (dept.children) {
      const child = dept.children.find(c => c.id === deptId)
      if (child) return dept.name
    }
  }
  return ''
}

// 关闭模态框
function closeModal() {
  showModal.value = false
}

// 保存部门
async function saveDept() {
  if (!form.name.trim()) {
    ElMessage.warning('请输入部门名称')
    return
  }
  if (!form.code.trim()) {
    ElMessage.warning('请输入部门编码')
    return
  }

  try {
    if (isEdit.value) {
      await updateDept(form.id, {
        name: form.name,
        code: form.code,
        sort: form.sort,
        managerUserId: form.managerUserId,
        phone: form.phone,
        status: form.status,
        parentId: form.parentId
      })
      ElMessage.success('修改成功')
    } else {
      await createDept({
        name: form.name,
        code: form.code,
        sort: form.sort,
        managerUserId: form.managerUserId,
        phone: form.phone,
        status: form.status,
        parentId: form.parentId || null
      })
      ElMessage.success('新增成功')
    }
    await fetchDepts()
    closeModal()
  } catch (error) {
    ElMessage.error(error.message || '操作失败')
  }
}

// 删除部门
function handleDelete(dept) {
  pendingDelete.value = dept
  showDeleteModal.value = true
}

// 确认删除
async function confirmDelete() {
  if (pendingDelete.value) {
    try {
      await deleteDept(pendingDelete.value.id)
      ElMessage.success('删除成功')
      await fetchDepts()
    } catch (error) {
      ElMessage.error(error.message || '删除失败')
    }
  }
  closeDeleteModal()
}

// 关闭删除确认弹窗
function closeDeleteModal() {
  showDeleteModal.value = false
  pendingDelete.value = null
}
</script>

<style scoped>
.tree-toggle {
  transition: transform 0.2s;
}
.tree-toggle.expanded {
  transform: rotate(90deg);
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
